<template>
  <div>
    <div class="pc">
      <div>
        <!-- header -->
        <div class="flex-between">
          <div class="flex-align">
            <div class="talk-icon">
              <img :src="staticPath('/static/icon/u_comment-alt-dots.svg')" alt="런치톡" class="svg-primary">
            </div>
            <div class="talk-title">런치톡</div>
          </div>
          <div>{{ reqEmailStatus }}</div>
        </div>

        <div style="margin-top: 12px">
          <template v-if="userId">
            <select v-if="services.length>0"
              class="input-border" v-model="selectedTalk">
              <option v-for="(item,idx) in services"  :key="`opt-talk-${idx}`"
                :value="item.id">{{ item.name }}</option>
            </select>
            <div class="input-border" v-else>서비스 없음</div>
          </template>
          <div class="radio-group">
            <div class="radio-item" v-for="(item,idx) in option" :key="`opt-${idx}`">
              <input type="radio" v-model="selectedOption" :id="`opt-${idx}`" :value="item.value">
              <label :for="`opt-${idx}`">{{ item.label }}</label>
            </div>
          </div>
        </div>

        <!-- content -->
        <div class="content-wrapper">
          <div class="talk-content" ref="pc_content">
            <template v-for="(item,idx) in list">
              <div :style="itemStyle(idx)" :key="'msg-'+idx">
                <div v-if="!item.user">
                  <!-- 관리자 작성 -->
                  <div class="flex-end" style="margin-bottom:8px"
                       v-if="idx === list.length -1 || (idx < list.length-1 &&
                       (list[idx+1].user || (list[idx+1].admin_name !== item.admin_name)))">
                    <div class="lp-logo">
                      <img :src="staticPath('/static/img/ic_logo.svg')">
                    </div>
                    <div class="subtitle4 sub2" style="margin-left: 8px">{{ item.admin_name }}</div>
                  </div>
                  <div class="message-from">
                    <div style="margin-right:4px;text-align:right">
                      <img :src="staticPath('/static/icon/u_trash-alt.svg')" class="svg-sub3 trash"
                           @click="clickTrash(idx)">
                      <span class="body6 sub3" style="flex:1">{{ datesFormat(item.created_time, 'time_2') }}</span>
                    </div>
                    <talk-images v-if="item.imgs && item.imgs.length>0" :images="item.imgs"></talk-images>
                    <div v-else class="message">
                      <talk-memo-msg v-if="item.memo" :talkId="selectedTalk" :item="item"></talk-memo-msg>
                      <template v-else>
                        <talk-file v-if="item.file" :item="item"></talk-file>
                        <template v-else>{{ item.message }}</template>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- 유저 답변 -->
                <div v-else>
                  <div class="flex-align" style="margin-bottom:8px"
                       v-if="idx === list.length -1 || (idx < list.length-1 && list[idx+1].admin)">
                    <div class="lp-logo">
                      <img :src="staticPath('/static/img/ic_logo.svg')">
                    </div>
                    <div class="subtitle4 sub2" style="margin-left: 8px">{{ item.user_name }} 님</div>
                  </div>
                  <div class="message-to">
                    <div>
                      <talk-images v-if="item.imgs && item.imgs.length>0" :images="item.imgs"></talk-images>
                      <div v-else class="message">
                        <talk-file v-if="item.file" :item="item"></talk-file>
                        <template v-else>{{ item.message }}</template>
                      </div>
                    </div>
                    <div class="body6 sub3" style="margin-left:4px">{{ datesFormat(item.created_time, 'time_2') }}</div>
                  </div>
                </div>
              </div>

              <div class="flex-align" style="margin:16px 0"
                   :key="'date-'+idx" v-if="idx === list.length -1 || idx < list.length-2 && !compareDate(item, list[idx+1])">
                <div class="divider-date"></div>
                <div class="txt-date">{{ datesFormat(item.created_time, 'date_8') }}</div>
                <div class="divider-date"></div>
              </div>
            </template>
          </div>
        </div>

        <div style="margin-bottom:12px">
          <!-- 파일 전송 -->
          <input type="file" id="file-multi-uploader"
                 @change="onFileChange" multiple
                 accept="image/gif, image/jpeg, image/png, .docx, .pptx, .xlsx, .hwp, .pdf">
          <div class="flex-align">
            <div style="margin-right:8px">
              <select v-model="sendType" class="input-border">
                <option value="basic">고객에게 전달</option>
                <option value="memo">내부메모</option>
              </select>
            </div>
            <label for="file-multi-uploader" v-if="sendType !== 'memo'">
              <div class="button is-gray flex-align unselect" style="border-radius:8px;width:100px;height:42px !important">
                <img :src="staticPath('/static/icon/u_file-upload.svg')" class="svg-sub3">
                <span class="body4-medium sub3" style="margin-left:4px">파일 첨부</span>
              </div>
            </label>
            <!--<div class="body6 sub3" style="margin-left:8px">jpg, gif, png, hwp, pdf, pptx, docx, xlsx<br>(최대 5개, 10MB까지 등록)</div>-->
          </div>
        </div>
        <template v-if="sendType==='memo'">
          <talk-memo ref="memo">
            <div class="box-send" style="margin-bottom:12px">
            <textarea v-model="sendData.message" @keyup="e => sendData.message = e.target.value" rows="6"></textarea>
            </div>
          </talk-memo>
          <button class="button is-primary" style="width:100%" @click="clickSend">전송하기</button>
          <div class="body5-medium sub3" style="margin-top:6px;text-align: right">Ctrl + Enter로 바로 전송</div>
        </template>

        <!-- 메시지 전송 -->
        <template v-else>
          <div class="box-send">
            <textarea v-model="sendData.message" @keyup="e => sendData.message = e.target.value" rows="6"></textarea>
            <button class="button is-primary" style="width:100%" @click="clickSend">전송하기</button>
          </div>
          <div class="body5-medium sub3" style="margin-top:6px;text-align: right">Ctrl + Enter로 바로 전송</div>
        </template>
      </div>

      <div class="spinner" v-if="vSpinner">
        <img :src="staticPath('/static/icon/spinner.gif')" alt="스피너">
      </div>
    </div>

    <div class="del-modal">
      <sweet-modal overlay-theme="dark" ref="delModal" width="564px"
                   :hide-close-button="true">
        <div class="subtitle4">메세지를 삭제하시면 복구되지 않습니다.<br>정말로 삭제하시겠습니까?</div>
        <div class="buttons flex-between body5-medium">
          <div style="width:50%;padding-right:8px">
            <button class="button body2-bold" style="width:100%;height:52px" @click="$refs.delModal.close()">취소</button>
          </div>
          <div style="width:50%;padding-left:8px">
            <button class="button is-primary margin-left-16 body2-bold"
                    style="width:100%;height:52px;"
                    @click="clickDelete">확인</button>
          </div>
        </div>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
  import LpDropdown from "./LpDropdown";
  const io = require('socket.io-client');
  import {SweetModal} from 'sweet-modal-vue'
  import TalkFile from "./TalkFile";
  import TalkImages from "./TalkImages";
  import LpCheckBool from "./LpCheckBool";
  import TalkMemo from "./TalkMemo";
  import TalkMemoMsg from "./TalkMemoMsg";

  export default {
    name: "LaunchTalk",
    components: {
      TalkMemoMsg,
      TalkMemo,
      LpDropdown,
      LpCheckBool,
      SweetModal,
      TalkFile,
      TalkImages
    },
    props: {
      userId: {
        type: Number
      },
      talkId: {
        type: Number,
        default: 0
      },
      isMemo: {
        type: Boolean,
        default: false
      }
    },
    created() {
      this.selectedTalk = this.talkId;
      /*if(this.isMemo) {
        this.sendType ='memo';
      }*/
      // 기본값 내부메모로 변경(22.12.12)
      this.sendType ='memo';

      this.init();
      if(this.userId) {
        this.getTalks();
      } else {
        this.getTalk();
        this.getData();
      }
      this.setSocketIO();
      window.addEventListener('keydown', this.keydownFunc);
      window.addEventListener('keyup', this.keyupFunc);
    },
    destroyed() {
      this.socket.disconnect();
      window.removeEventListener('keydown', this.keydownFunc);
      window.removeEventListener('keyup', this.keyupFunc);
    },
    computed: {
      reqEmailStatus() {
        return this.req_email ? '(답변을 이메일 알림으로 받습니다)' : '(답변을 이메일 알림으로 받지 않습니다)';
      }
    },
    data() {
      return {
        option: [],
        selectedTalk: 0,
        selectedOption: 0,
        sendType: 'basic',
        keydownCtrl: false,
        socket: undefined,
        files: [],
        fileLength: 0,
        req_email: false,
        selectedItem: -1,
        list: [],
        sendData: {
          message: '',
          files: []
        },
        cur_page: 1,
        total_page: 1,
        loading: false,
        vSpinner: false,
        services: [],
        talks: []
      }
    },
    methods: {
      keyupFunc(e) {
        let key = e.key;

        // Ctrl키, Cmd키
        if (key === 'Control' ||
          key === 'Meta') {
          this.keydownCtrl = false;
        }
      },
      keydownFunc(e) {
        let keyCode = e.keyCode;
        let key = e.key;

        // Ctrl키, Cmd키
        if (key === 'Control' ||
          key === 'Meta') {
          this.keydownCtrl = true;
        }

        // 메시지 전송 (ctrl + enter)
        if(keyCode === 13 && this.keydownCtrl) {
          this.clickSend();
          e.preventDefault();
        }
      },
      setSocketIO() {
        this.socket = io.connect('https://master-dev.launchpack.co.kr:3000');
        setTimeout(() => {
          this.socket.on('message', (msg) => {
            if (msg.type === 'launch_talk' && msg.talk === this.selectedTalk && msg.user) {
              this.list.splice(0, 0, ...msg.msg);
              this.setRead();
            }
          });
        }, 500);
      },
      staticPath(img) {
        return `https://launchpack.co.kr${img}`;
      },
      compareDate(cur, prev) {
        const curDate = cur.created_time.split(' ')[0];
        const prevDate = prev.created_time.split(' ')[0];
        return curDate === prevDate;
      },
      clickSend() {
        this.send();
      },
      send() {
        if (this.sendData.message.trim() === '') {
          return;
        }
        let params = {
          message: this.sendData.message,
          memo: this.sendType === 'memo'
        };
        if(this.$refs.memo) {
          params.info = this.$refs.memo.getValue();
          if(params.info.cat1_id) {
            params.cat1_id = params.info.cat1_id;
          }
          params.file = params.info.file;
          delete params.info.file;
        }

        this.$axios.post(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.selectedTalk}/message`, params).then(res => {
          if (res.status === 200) {
            this.list = res.data.msgs.concat(this.list);
            this.sendData.message = '';
            this.selectedOption = 0;

          }
        })
      },
      clickTrash(item) {
        this.selectedItem = item;
        this.$refs.delModal.open();
      },
      initScrollEvent() {
        this.$nextTick(() => {
          this.$refs.pc_content.addEventListener('scroll', this.onScroll);
          //this.$refs.mobile_content.addEventListener('scroll', this.onScroll);
        });
      },
      onScroll(e) {
        if (e.target.scrollTop < 100) {
          this.getData();
        }
      },
      async init() {
        let res_cat = await this.$axios.get(this.getUrl('memo_category'));
        this.option = [
          { label: '전체', value: 0 },
          { label: '맞춤제작', value: 'service_inquiry' },
          { label: '디자인수정', value: 'design_inquiry' }
        ].concat(res_cat.data.map(i => {
          return {
            label: i.name,
            value: i.id,
            type: 'category'
          }
        }));
      },
      async getTalks() {
        let res = await this.$axios.get(this.getUrl(`launchpack/talk_user/${this.$route.query.id}`));
        this.talks = res.data;
        this.services = this.talks.filter(i => i.category === '서비스');
        if(this.services.length>0) {
          this.selectedTalk = this.services[0].id;
        } else {
          let talk = this.talks.filter(i => i.category !== '');
          if(talk.length > 0) {
            this.selectedTalk = talk[0].id;
          } else {
            talk = this.talks.filter(i => i.category === '');
            if(talk.length> 0) {
              this.selectedTalk = talk[0].id;
            }
          }
        }
      },
      getTalk() {
        this.$axios.get(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.selectedTalk}`).then(res => {
          this.req_email = res.data.req_email;
          this.list = [];
          this.cur_page = 1;
          this.getData();
        });
      },
      getData() {
        if (this.loading) return;

        if (this.cur_page <= this.total_page) {
          this.loading = true;
          let query_param = {
            ordering: '-created_time',
            page_num: this.cur_page,
            page_length: 50
          };
          if(this.selectedOption!==0) {
            if(this.selectedOption === 'service_inquiry') {
              let talk = this.talks.filter(i=> i.category === '맞춤제작');
              if(talk.length>0) {
                this.selectedTalk = talk[0].id;
              }
              query_param['service_inquiry_isnull'] = 'false';
            }
            else if(this.selectedOption === 'design_inquiry') {
              query_param['design_inquiry_isnull'] = 'false';
            }
            else {
              query_param['cat1'] = this.selectedOption;
            }
          }

          this.$axios.get(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.selectedTalk}/message`,
                          {params: query_param}).then(res => {
            this.loading = false;
            this.total_page = res.data.total_page;
            this.list = this.list.concat(res.data.data);
            this.setRead();
            if (this.cur_page === 1) {
              this.initScrollEvent();
            }
            this.cur_page++;
          }).catch(() => {
            this.loading = false;
          });
        }
      },
      clickDelete() {
        this.$axios.delete(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.selectedTalk}/message/${this.list[this.selectedItem].id}`).then(res => {
          if (res.status === 200) {
            removeIndex(this.list, this.selectedItem);
          }
        });
        this.$refs.delModal.close();
      },
      itemStyle(idx) {
        let deco = {};
        if (idx > 0 && this.list[idx - 1].author !== this.list[idx].author) {
          deco.marginTop = '32px';
        }
        return deco;
      },
      onFileChange(e) {
        this.fileLength = e.target.files.length;
        if (this.fileLength > 5) {
          this.toast('파일을 최대 5개 이하로 선택해주세요');
          return;
        }

        for (let file of e.target.files) {
          let reader = new FileReader();
          reader.onload = (f) => {
            let ext = '';
            let files = file.name.split('.');
            if (files.length > 1) {
              ext = files[files.length - 1];
            }
            if (this.files.filter(item => {
              return item.name === file.name && item.size === file.size
            }).length === 0) {
              this.files.push({
                name: file.name,
                file: f.target.result,
                size: file.size,
                extension: ext
              })
            }
          };
          reader.readAsDataURL(file);
        }
      },
      async uploadFiles() {
        const extImgs = ['png', 'jpg', 'jpeg', 'PNG', 'JPG', 'JPEG'];

        let arr = [
          {
            imgs: this.files.filter(i => {
              return extImgs.indexOf(i.extenstion) > -1
            }).map(i => {
              return i.file
            })
          },
          {
            file: this.files.filter(i => {
              return extImgs.indexOf(i.extenstion) === -1
            }).map(i => {
              return i.file
            })
          }
        ];
        this.vSpinner = true;
        for (let params of arr) {
          if (params[Object.keys(params)[0]].length > 0) {
            try {
              let res = await this.$axios.post(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.selectedTalk}/message`, params);
              this.list.splice(0, 0, ...res.data.msgs);
              this.setRead();
            } catch {
              console.log('err')
            }
          }
        }
        this.vSpinner = false;
        this.fileLength = 0;
        this.files = [];
      },
      setRead() {
        let ids = this.list.filter(item => { return !item.read && item.user !== null }).map(item => { return item.id });
        if(ids.length>0) {
          this.$axios.post(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.selectedTalk}/message/read`, {ids:ids}).then(res=>{
            if(res.status === 200) {
              this.list.filter(item => { return ids.indexOf(item.id)>-1 }).forEach(item => { item.read = true; });
            }
          });
        }
      },
    },
    watch: {
      selectedTalk() {
        this.getTalk();
      },
      selectedOption(){
        this.list = [];
        this.cur_page = 1;
        this.getData();
      },
      files(n) {
        if (this.fileLength > 0 && n.length === this.fileLength) {
          this.uploadFiles();
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .talk-icon
    background-color $primary-light2
    width 32px
    height 32px
    display flex
    justify-content center
    align-items center
    border-radius 100%

    img
      width 18px
      height 18px

  .talk-title
    color $main
    font-size 24px
    font-weight 500
    margin-left 8px

  .content-wrapper
    border-radius 8px
    margin 16px 0
    overflow hidden

  .talk-content
    border 1px solid $gray2
    padding 24px
    border-radius 8px
    background-color $gray2
    height 500px
    overflow-y auto
    display flex
    flex-direction column-reverse

  .message-from
  .message-to
    display flex
    align-items flex-end
    margin 8px 0

  .message-from
    justify-content flex-end

  .message
    font-size 14px
    padding 10px 12px
    border-radius 8px
    background-color white
    max-width 480px
    color $main
    white-space pre-line

  .lp-logo
    background-color $sub
    border-radius 100%
    width 24px
    height 24px
    display flex
    align-items center
    justify-content center

    img
      width 10px
      height 15px

  textarea
    border 0
    padding 12px 16px
    border-radius 8px
    width 100% !important
    resize none

  input[type=file]
    position absolute
    width 0
    height 0
    border 0 !important

  textarea:focus
    border 0
    outline 0

  .box-send
    border-radius 8px
    border 1px solid $gray1
    overflow hidden
    background-color white

    .button
      border-top-left-radius 0
      border-top-right-radius 0

  .trash
    width 18px
    height 18px
    vertical-align sub
    margin-right 4px

  .trash:hover
    filter invert(54%) sepia(46%) saturate(5884%) hue-rotate(360deg) brightness(100%) contrast(110%)
    cursor pointer

  .txt-date
    font-size 14px
    font-weight 400
    text-align center
    padding 0 20px
    color $sub3

  .divider-date
    flex 1
    height 1px
    background-color $sub5

  .spinner
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background rgba(0,0,0,0.7)
    display flex
    align-items center
    justify-content center
    border-radius 12px

  .radio-group
    display flex
    align-items center
    gap 4px 12px
    flex-wrap wrap
    margin-top 12px

  .radio-item
    display flex
    align-items center
    gap 4px
    font-size 14px

  .pc
    .spinner
      width 146px
      height 146px
  .mobile
    .spinner
      width 78px
      height 78px
      img
        width 34px
        height 34px


  @media (max-width: 1024px)
    .talk-content
      border 0
      padding 24px 24px 60px 24px
      background-color $gray2
      margin-top 60px
      height calc(100vh - 120px)
      overflow-y auto

    .message
      max-width 232px

    .box-mobile-send
      position fixed
      bottom 0
      left 0
      background-color white
      border-top 1px solid $gray1
      width 100%
      min-height 60px
      display flex
      align-items center
      justify-content space-between
      padding 0 16px

    #input-send
      padding 8px 16px
      flex 1
      max-height 120px
      overflow-y auto

    #input-send:focus
      outline 0

    .txt-date
      font-size 10px

    .trash
      width 14px
      height 14px
</style>

<style lang="stylus">
  .del-modal .sweet-modal.is-mobile-fullscreen
    top 50% !important
    left 50% !important
    transform translate(-50%, -50%) !important

  .del-modal .sweet-content
    padding-bottom 12px !important

  @media (min-width: 501px)
    .del-modal .sweet-modal
      height 280px

    .del-modal .sweet-content
      padding-top 72px !important
    .del-modal
      .button
        margin 0 8px
        height 52px !important

    .buttons
      padding 64px 16px 0 !important

  @media (max-width: 500px)
    .del-modal .sweet-modal
      max-width 80vw !important
      height 184px

      .subtitle4
        font-size 14px

      .body2-bold
        font-size 13px

      .button
        height 36px !important
        margin 0 8px

    .del-modal .sweet-content
      padding-top 38px !important

    .buttons
      padding 38px 16px 0 !important
</style>
